<ng-content select="fui-name-value-list-entry"></ng-content>
<fui-empty [description]="emptyDescription" *ngIf="entries.length" [title]="emptyTitle"></fui-empty>
